var map = {
	"./about-line.svg": "db2c",
	"./announcements-line.svg": "a7f3",
	"./arrow-2.svg": "7151",
	"./arrow.svg": "d4d9",
	"./cart.svg": "c0c3",
	"./cart2.svg": "0db1",
	"./clock.svg": "3175",
	"./clock2.svg": "5047",
	"./close.svg": "bb7c",
	"./comment-line.svg": "7d01",
	"./contacts-line.svg": "6ebf",
	"./facebook.svg": "7e4b",
	"./flag.svg": "cc69",
	"./instagram.svg": "48d6",
	"./leaf.svg": "3cd9",
	"./line.svg": "7fe7",
	"./main-line.svg": "6dba",
	"./menu-line.svg": "7e77",
	"./message.svg": "5f5b",
	"./phone.svg": "1f9a",
	"./placeholder.svg": "1311",
	"./reports-line.svg": "2d7c",
	"./telegram.svg": "e44e",
	"./top.svg": "ffb0",
	"./tour-line.svg": "aca4",
	"./vk.svg": "b6d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";